import { Link } from "react-router-dom";
import { Zap, Sparkles, ArrowRight, ExternalLink } from "lucide-react";
import NewsletterSignup from "@/components/NewsletterSignup";
import { UPSELL } from "@/lib/upsell";

const PORTFOLIO_URL = "https://www.vibeops.technology";

export default function Footer() {
  return (
    <footer className="border-t border-white/8 mt-24 bg-slate-950/50">
      {/* Persistent SaaS LaunchPad CTA — on every page */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12">
        <div className="glass rounded-2xl p-6 sm:p-8 border-indigo-500/30 relative overflow-hidden">
          <div className="aurora" />
          <div className="relative z-10 flex flex-col md:flex-row md:items-center gap-5">
            <div className="w-12 h-12 rounded-xl bg-indigo-500/15 border border-indigo-500/30 flex items-center justify-center shrink-0">
              <Sparkles className="w-6 h-6 text-indigo-400" />
            </div>
            <div className="flex-1">
              <p className="text-xs font-mono uppercase tracking-widest text-indigo-400 mb-1">{UPSELL.cta}</p>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-50">Ready to actually build it? Meet {UPSELL.name}.</h3>
              <p className="text-slate-400 mt-1.5 max-w-xl text-sm">{UPSELL.tagline} Go from validated opportunity to launched SaaS with the ultimate builder companion.</p>
            </div>
            <a href={UPSELL.url} target="_blank" rel="noreferrer" className="shrink-0" data-testid="footer-saaslaunchpad-cta">
              <span className="inline-flex items-center gap-1.5 h-11 px-6 rounded-lg bg-indigo-500 hover:bg-indigo-400 text-white font-semibold transition-colors">
                Explore {UPSELL.name} <ArrowRight className="w-4 h-4" />
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-400 to-indigo-500 flex items-center justify-center">
              <Zap className="w-4 h-4 text-slate-950" fill="currentColor" />
            </div>
            <span className="font-display font-extrabold text-slate-50">NexxVibe</span>
          </Link>
          <p className="text-sm text-slate-500 max-w-xs mb-4">The Builder Intelligence Platform. Discover, validate, and build better software opportunities with AI.</p>
          <div className="max-w-xs"><NewsletterSignup source="footer" /></div>
        </div>
        <FooterCol title="Discover" links={[["/discover","Opportunity Feed"],["/trends","Trend Radar"],["/pain-points","Pain Points"]]} />
        <FooterCol title="Build" links={[["/generate","Idea Generator"],["/validate","Validator"],["/revenue","Revenue Calc"]]} />
        <FooterCol title="Platform" links={[["/pricing","Free — $0"],["/community","Community"],["/leaderboard","Leaderboard"]]} />
      </div>

      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-600">
          <span>© {new Date().getFullYear()} NexxVibe — Bloomberg Terminal for Software Opportunities.</span>
          <a href={PORTFOLIO_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-slate-400 hover:text-cyan-300 transition-colors" data-testid="footer-portfolio-link">
            <Sparkles className="w-3.5 h-3.5" />See more great products from the NexxVibe builder
            <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="text-xs uppercase tracking-wider text-slate-400 mb-3 font-mono">{title}</p>
      <ul className="space-y-2">
        {links.map(([to, label]) => (
          <li key={to}><Link to={to} className="text-sm text-slate-500 hover:text-cyan-300 transition-colors">{label}</Link></li>
        ))}
      </ul>
    </div>
  );
}
